// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1Qf1X","file":"styles_file__2iJle"};